import React, {useEffect, useState} from "react";
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges} from "../../../common/utils/field-change-util";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const ACTION_FIELDS_LIST = [
    /*{attribute: 'title', label: 'Add Title', type: 'checkbox', readOnly: false, group: 'config', cssClass: 'text-green-600 -mb-6'},*/
    {
        attribute: 'mainContent',
        label: 'Main Content',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 1,
        group: 'config',
        cssClass: 'text-green-600 -mb-6'
    },
    {
        attribute: 'expandMainContent',
        label: 'Expand Main Content',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 2,
        group: 'config',
        cssClass: 'text-green-600 -mb-6'
    },
    /*{
        attribute: 'sectionTitles',
        label: 'Select SECTION for Section Titles',
        type: 'checkbox',
        readOnly: false,
        group: 'config',
        cssClass: 'text-purple-600 -mb-6'
    },*/
    {
        attribute: 'rewriteSectionTitles',
        label: 'Rewrite Section Titles',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 3,
        group: 'config',
        cssClass: 'text-purple-600 -mb-6'
    },
    {
        attribute: 'expandSectionContent',
        label: 'Expand Sections',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 4,
        group: 'config',
        cssClass: 'text-purple-600 -mb-6'
    },
    {
        attribute: 'mainContentLinks',
        label: 'Add Links for Main Content',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 5,
        group: 'config',
        cssClass: 'text-purple-600 -mb-6'
    },
    /*{
        attribute: 'sectionContentLinks',
        label: 'Add Links for Section Content',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 6,
        group: 'config',
        cssClass: 'text-purple-600 -mb-6'
    },*/
    {
        attribute: 'addImages',
        label: 'Add Images for Main Content',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 7,
        group: 'config',
        cssClass: 'text-blue-600 -mb-6'
    },
    {
        attribute: 'excerpts',
        label: 'Add Excerpts',
        type: 'checkbox',
        readOnly: false,
        displayOrder: 8,
        group: 'config',
        cssClass: 'text-green-600 -mb-6'
    },
    /*{attribute: 'featuredImage', label: 'Design Featured Image', type: 'checkbox', readOnly: false, group: 'config', cssClass: 'text-blue-600 -mb-6'},
    {attribute: 'publishPost', label: 'Publish Post', type: 'checkbox', readOnly: false, group: 'config', cssClass: 'text-red-600 -mb-6'},*/
];

const ProductBlogPostAutomationConfig = ({
                                             actionConfig,
                                             setActionConfig,
                                             startBlogPostContentGeneration
                                         }) => {
    /*const [actionConfig, setActionConfig] = useState({});*/
    const [initialStep, setInitialStep] = useState(true);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            init();
        }
    }, [initialStep]);

    const init = () => {
        let existingActionConfig = {...actionConfig};
        const newActionConfig = {};

        ACTION_FIELDS_LIST.forEach((action) => {
            newActionConfig[action.attribute] = existingActionConfig[action.attribute] || false;
        });

        setActionConfig(newActionConfig);
    }

    const handleFilterChanges = (event) => {
        let existingActionConfig = {...actionConfig};
        existingActionConfig = handleFieldValueChanges(event, existingActionConfig);
        setActionConfig(existingActionConfig);
    }

    return (
        <>
            <div className={'p-6 border border-gray-400 bg-white rounded-xl'}>

                <div className={'text-lg text-purple-600 font-semibold mb-2'}>
                    Automation Configuration
                </div>

                <div className={'mb-2'}>
                    {!initialStep &&
                        <RenderFields
                            parentForm={actionConfig}
                            handleDetailChanges={handleFilterChanges}
                            fieldList={ACTION_FIELDS_LIST}
                            enableEdit={true}
                            fieldClassName={''}/>
                    }
                </div>

                <div className={'flex justify-center items-center mt-8 mb-2 text-center'}>
                    <button
                        className="button-green px-4 py-2"
                        onClick={startBlogPostContentGeneration}>
                        <span>Start Blog Post Sync</span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default ProductBlogPostAutomationConfig
